import { jsx } from "react/jsx-runtime";
import {
  getTokens,
  getVariable,
  getVariableValue,
  useMediaPropsActive,
  useTheme
} from "@tamagui/core";
function themed(Component) {
  const wrapped = (propsIn) => {
    const props = useMediaPropsActive(propsIn);
    const theme = useTheme();
    const color = getVariable(
      (props.color in theme ? theme[props.color] : void 0) || props.color || (!props.disableTheme ? theme.color : null) || "#000"
    );
    const size = typeof props.size === "string" ? getVariableValue(getTokens().size[props.size] || props.size) : props.size;
    return /* @__PURE__ */ jsx(Component, { ...props, color, size });
  };
  return wrapped;
}
export {
  themed
};
//# sourceMappingURL=themed.js.map
